export default "__VITE_ASSET__d4249fca__"